import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { CoreService } from 'src/app/core/helpers/core.service';

@Component({
  selector: 'loyaltic-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.scss']
})
export class ResetPasswordComponent implements OnInit {
  resetCode = '';
  email: any;
  password: any;
  confirmPassword: any;
  showPassword = false;
  showConfirmPassword = false;

  constructor(private route: ActivatedRoute, private coreService: CoreService, private toast: ToastrService,
    private router: Router) {
    this.route.queryParams.subscribe(params => {
      // console.log('params', encodeURIComponent(params.code));
      this.resetCode = encodeURIComponent(params.code);
    });
  }

  ngOnInit() {
  }

  onSubmit(formRef) {
    if (this.password !== this.confirmPassword) {
      return;
    }

    const body = {
      Email: this.email,
      Password: this.password,
      Code: this.resetCode,
    };

    this.coreService.resetPassword(body).then((resetPasswordResponse: any) => {
      console.log(resetPasswordResponse);
      this.toast.success('Password reset successfully!', 'Success');
      this.router.navigate(['']);
    }).catch((errorResponse: any) => {
      if (errorResponse.error.messageKey === 'error-already-registered') {
        this.toast.error('User already exists, try with  other email', 'Error');
        return;
      }
    });
  }

}
